export default __webpack_public_path__ + "static/cabezales-aeeb5333c6fde08d5e201f2aab4ba4ed.png";